import '../../assets/css/Modal.css';
import styles from '../../assets/jss/Modal/Modal';
import {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {makeStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import preMeal from '../../assets/img/preMeal.svg';
import postMeal from '../../assets/img/postMeal.svg';
import NoMeal from '../../assets/img/undefinedMeal.svg';
import ClockIcon from '../../assets/img/clock-purple.svg';

const useStyles = makeStyles(styles);

const Modal = forwardRef((props, ref) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [description, setDescription] = useState(null);
  const [edit, setEdit] = useState(false);
  const {data, direction} = props;
  const [alert, setAlert] = useState({show: false, msg: '', type: ''});
  let id;
  let dateNumeric;
  let time;
  let weekday;
  let testResult;
  let mealStatus;
  let glucoseStatus;
  let timeColor;

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [open]);

  if (data) {
    id = data.id;
    dateNumeric = data.dateNumeric;
    time = data.time;
    weekday = data.weekday;
    testResult = data.testResult;
    mealStatus = data.mealStatus;
    glucoseStatus = data.glucoseStatus;
  }

  let glucoseStatusColor =
    glucoseStatus === 0
      ? 'var(--medium-green)'
      : glucoseStatus === 1
      ? 'var(--light-orange)'
      : glucoseStatus === 2
      ? 'var(--pink)'
      : '';

  const showAlert = (show = false, type = '', msg = '') => {
    setAlert({show, type, msg});
  };

  useImperativeHandle(ref, () => {
    return {
      open: () => setOpen(true),
      close: () => setOpen(false),
    };
  });

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            onClick={() => setOpen(false)}
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
              transition: {
                duration: 0.3,
              },
            }}
            exit={{
              opacity: 0,
              transition: {
                delay: 0.3,
              },
            }}
            className='modal-backdrop'
          />
          <motion.div
            style={{zIndex: 10, border: `1px solid ${glucoseStatusColor}`}}
            initial={{
              // transform: 'scale(0) rotateX(-360deg)',
              opacity: 0,
              transition: {
                delay: 0.3,
              },
            }}
            animate={{
              // transform: 'scale(1) rotateX(0deg)',
              opacity: 1,
              transition: {
                duration: 0.5,
              },
            }}
            exit={{
              opacity: 0,
              transition: {
                delay: 0.3,
              },
            }}
            className='modal-content-wrapper'>
            <motion.div
              className='modal-content'
              initial={{
                x: 100,
                opacity: 0,
              }}
              animate={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.3,
                  duration: 0.3,
                },
              }}
              exit={{
                x: 100,
                opacity: 0,
                transition: {
                  duration: 0.3,
                },
              }}>
              <Grid container dir='rtl' justifyContent={'center'}>
                <Grid container justifyContent={'center'}>
                  <Grid item>
                    <p className={classes.dateModal}>{weekday}</p>
                  </Grid>

                  <Grid
                    item
                    xs={4}
                    display='flex'
                    alignItems={'center'}
                    flexDirection={'row-reverse'}>
                    <img
                      src={ClockIcon}
                      alt='clock icon'
                      style={{height: '17px', marginRight: '5px'}}
                    />
                    <p className={classes.Hour} style={{color: '#53585f'}}>
                      {time}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  flexDirection={direction}
                  display='flex'
                  justifyContent='center'
                  alignItems='center'
                  xs={12}
                  m='40px auto'>
                  <p className={classes.sugarModal}>
                    <span style={{color: glucoseStatusColor}}>
                      {testResult}
                    </span>
                  </p>
                  <p className={classes.sugarUnit}>
                    <span style={{color: glucoseStatusColor}}> mg/dl</span>
                  </p>
                </Grid>
                <Grid container justifyContent={'center'}>
                  <Grid item>
                    <div
                      style={{
                        width: mealStatus !== 0 ? '100%' : '100%',
                        height: '45px',
                        margin: '0 auto',
                        padding: '0 10px 0',
                        display: 'flex',
                      }}>
                      {mealStatus !== 0 && (
                        <img
                          style={{width: '32px', height: '25px'}}
                          src={
                            mealStatus === 1
                              ? postMeal
                              : mealStatus === 2
                              ? preMeal
                              : ''
                          }
                          alt=''
                        />
                      )}
                      {mealStatus !== 1 && mealStatus !== 2 && (
                        <img
                          style={{
                            width: '32px',
                            height: '25px',
                            marginRight: '5px',
                          }}
                          src={NoMeal}
                          alt=''
                        />
                      )}{' '}
                      <span
                        style={{
                          paddingLeft:
                            mealStatus !== 1 || mealStatus !== 2
                              ? '5px'
                              : '10px',
                          fontSize: '18px',

                          color: '#585858',
                          width: '100%',
                          textAlign: 'left',
                        }}>
                        {mealStatus === 1
                          ? 'بعد از غذا'
                          : mealStatus === 2
                          ? 'پیش از غذا'
                          : 'زمان تست مشخص نشده'}
                      </span>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
});
export default Modal;
